import { paginatedIndexRouteOptions } from './paginatedIndexQuery';

/**
 * Route helper utilities for Carousel Posts.
 *
 * Carousel posts are a single global resource. Each record has a site_context,
 * but CRUD lives exclusively under /admin/carousel-posts. The siteContext
 * argument is kept for call-site compatibility but ignored.
 */
export function createCarouselPostRouteHelper(_siteContext, routes) {
  return {
    index: (extra) => routes.admin_carousel_posts(paginatedIndexRouteOptions(extra)),
    edit: (id) => routes.edit_admin_carousel_post(id, paginatedIndexRouteOptions()),
    update: (id) => routes.admin_carousel_post(id, paginatedIndexRouteOptions()),
    destroy: (id) => routes.admin_carousel_post(id, paginatedIndexRouteOptions()),
    reorder: () => routes.reorder_admin_carousel_posts(),
  };
}
